import {
  GetNominationInviteResponse,
  NominationServiceCapabilities,
  SubmitNominationFormPayload,
} from './nominationForm.types'

export const nominationService = ({
  client,
}: NominationServiceCapabilities) => ({
  getNomitationInvite: ({ inviteId }: { inviteId: string }) =>
    client.get<GetNominationInviteResponse>(
      `/v1/product-nomination-invites/${inviteId}`
    ),
  submitNominationForm: (data: SubmitNominationFormPayload) =>
    client.post('/v1/product-nominations', data),
})
